//
// RecordlistFieldOptions
//
// Field options for type 'recordlist'

import { observer } from 'mobx-react-lite'

import { ListFieldOptions } from './ListFieldOptions'

export const RecordlistFieldOptions = observer(function RecordlistFieldOptions({
    field,
    selectModified,
    worksheet,
    onAction,
    setSelected,
    renderkeyprefix,
}) {
    if (!field) return null

    return (
        <>
            <ListFieldOptions
                field={field}
                selectModified={selectModified}
                worksheet={worksheet}
                onAction={onAction}
                setSelected={setSelected}
                renderkeyprefix={renderkeyprefix}
            />
        </>
    )
})
